import OSS from 'ali-oss';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import css from './index.module.scss';
import { postImgAndPDF } from './../DialogForm/service';
import Template from '@/components/CorporatePurchase/components/Template';
import { generateImgFile, generatePDF, generatePDFFile } from '@/utils/PDFTemplate';
import { getCountryRegion } from '@/utils/countryRegion';
import generateTraceId from '@/utils/singUtil/generateTraceId';
import dayjs from '@/utils/dayjs';
import { localRegionMap } from '@/utils/time';
import { useGlobal } from '@/utils/useGlobal';

export default function TemplateModal({ obj, callback }: any) {
    const { useLang, useEffect, useRouter, getSystemTime, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dp3.crowdfunding.bundle.dialog');
    const curDate = dayjs.tz(getSystemTime(), localRegionMap[locale] || localRegionMap.us);
    const year = curDate.get('year');
    const month = String(curDate.get('month') + 1).padStart(2, '0');
    const day = String(curDate.get('date')).padStart(2, '0');
    const timestamp = getSystemTime();
    const isEU = getCountryRegion(locale) === 'eu';
    const HOST_STS = isEU ? process.env.NEXT_PUBLIC_STS_HOST_EU : process.env.NEXT_PUBLIC_STS_HOST;
    const uuid = generateTraceId();
    const [isLoading, setIsLoading] = useState(false);

    const handleDownload = () => {
        setIsLoading(true);
        const target = document.querySelector('.template-modal .template') as HTMLDivElement;
        const offsetLeft = target.offsetLeft;
        const offsetTop = target.offsetTop;
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.left = `${-offsetLeft}px`;
        container.style.top = `${-offsetTop}px`;
        const clonedElement = target.cloneNode(true);
        container.appendChild(clonedElement);
        document.body.appendChild(container);
        generatePDF(container, '御見積書-EcoFlow Japan', 0, 0, 0, 0, 0, () => {
            document.body.removeChild(container);
            setIsLoading(false);
        });
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'file_download',
                file_name: t('title'),
                button_name: t('download'),
                position: 1,
            });
        } catch (e) {
            console.error(e);
        }
    };

    const handlePrepareToOSS = async () => {
        try {
            let json1: any = { data: { region: '', bucket: '', endpoint: '' }, code: '' };
            const result1 = await fetch(`${HOST_STS}/system/oss/fileUpload/prepareSts`, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            json1 = await result1.json();
            try {
                const result2 = await fetch(`${HOST_STS}/system/oss/fileUpload/stsServer`, {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                });
                const json2 = await result2.json();
                if (json2?.StatusCode === '200') {
                    return { json1, json2 };
                }
            } catch (e) {
                console.log(e);
            }
        } catch (err: any) {
            console.error(err);
        }
    };

    const handleAsyncToOSS = async (file: any, json1: any, json2: any) => {
        // 准备
        const tempArr = file?.name?.split('.');
        const suffix = tempArr[tempArr.length - 1];
        // const url = `https://${json1?.data?.bucket}.${json1?.data?.endpoint}/website/quotation/${year}/${month}/${day}/${timestamp}/${uuid}.${suffix}`;

        try {
            const { AccessKeyId: accessKeyId, AccessKeySecret: accessKeySecret, SecurityToken: stsToken } = json2;
            const client = new OSS({
                // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
                region: json1?.data?.region,
                // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                accessKeyId,
                accessKeySecret,
                // 从STS服务获取的安全令牌（SecurityToken）。
                stsToken,
                // 填写Bucket名称。
                bucket: json1?.data?.bucket,
            });
            const rrrw = await client.put(`/website/quotation/${year}/${month}/${day}/${timestamp}/${uuid}.${suffix}`, file, {
                headers: {
                    'x-oss-object-acl': 'private', // 设为私有，不可直接访问
                },
            });
            if (rrrw?.res?.statusCode == 200) {
                return rrrw?.res?.requestUrls[0];
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            (async () => {
                const { json1, json2 }: any = await handlePrepareToOSS();
                const target = document.querySelector('.template-modal .template') as HTMLDivElement;
                const resImg = await generateImgFile(target, t('title'));
                const ossImgUrl = await handleAsyncToOSS(resImg, json1, json2);
                const resPdf = await generatePDFFile(target, t('title'));
                const ossPDFUrl = await handleAsyncToOSS(resPdf, json1, json2);
                const data = {
                    quoteId: obj?.quoteId,
                    quotePicUrl: ossImgUrl,
                    quotePdfUrl: ossPDFUrl,
                };
                await postImgAndPDF(data, locale);
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locale, obj?.quoteId]);

    return (
        <div className={`template-modal ${css['template-modal']}`}>
            <div className="content">
                <div className="content-header">
                    <p className="header-title">{t('header_title')}</p>
                    <svg className="close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={callback}>
                        <path d="M6 5L19 18M19 5L6 18" stroke="black" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="content-body">
                    <p className="text">{t('text')}</p>
                    <div className="template-wrapper">
                        <Template
                            isHideSeal={true}
                            obj={{ ...obj, date: `${year}/${month}/${day}`, tel: 'お問い合わせ:050-3090-2966' }}
                            langeKey={'dp3.crowdfunding.bundle.template'}
                        />
                    </div>
                    <button className="download" onClick={handleDownload}>
                        <span>{t('download')}</span>
                        {isLoading && <Spin indicator={<LoadingOutlined spin style={{ color: '#fff', marginLeft: '4px' }} />} />}
                    </button>
                </div>
            </div>
        </div>
    );
}
